export class CreditCardRegex {
    public static VISA(): RegExp {
        return new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
    }
    public static MasterCard(): RegExp {
        return new RegExp('^5[1-5][0-9]{14}$');
    }
    public static Discover(): RegExp {
        return new RegExp('^6(?:011|5[0-9]{2})[0-9]{12}$');
    }
    public static AMEX(): RegExp {
        return new RegExp('^3[47][0-9]{13}$');
    }
}

export class CardInfo {
    cardType: string;
    cvvFormat: string;
    cvvHelpText: string;
    cvvRegex: RegExp;
}

export class CreditCardUtility {
    public static ProcessingFee(req: {
        paymentAmount: number;
        feePercentage: number;
        minimumProcessingFee: number;
        feeRoundingThreshold?: number;
        roundProcessingChargeDigits?: number;
    }): number {
        const startProcessingFee = req.paymentAmount * (req.feePercentage / 100);
        let processingFee = 0;
        if (req.feeRoundingThreshold && req.roundProcessingChargeDigits) {
            return -1;
        }

        if (!req.paymentAmount) {
            return 0;
        }

        if (req.feeRoundingThreshold) {
            const fraction = startProcessingFee - Math.trunc(startProcessingFee);
            if (fraction <= req.feeRoundingThreshold) {
                processingFee = Math.trunc(startProcessingFee);
            } else {
                processingFee = Math.trunc(startProcessingFee) + 1;
            }
        }

        if (req.roundProcessingChargeDigits) {
            if (req.roundProcessingChargeDigits > 0) {
                processingFee =
                    (Math.round(startProcessingFee * req.roundProcessingChargeDigits * 100) /
                        req.roundProcessingChargeDigits) *
                    100;
            } else {
                processingFee = Math.round(startProcessingFee);
            }
        }

        if (processingFee < req.minimumProcessingFee) {
            processingFee = req.minimumProcessingFee;
        }

        return processingFee;
    }

    public static CardInfo(cardNumber: string): CardInfo {
        const ci = new CardInfo();

        ci.cardType = '??';
        ci.cvvHelpText = 'Please enter a card number';

        if (CreditCardRegex.Discover().test(cardNumber)) {
            ci.cardType = 'DISC';
            // SetCardImageLarge(imgDiscover);
            ci.cvvFormat = '000';
            ci.cvvHelpText =
                'Your CVV number is a 3-digit number located after your account number on the signature strip on the back of your card.';
            ci.cvvRegex = CCVRegex.VISA_Disc_MC_CCV();
        }
        if (CreditCardRegex.MasterCard().test(cardNumber)) {
            ci.cardType = 'MC';
            // SetCardImageLarge(imgMasterCard);
            ci.cvvFormat = '000';
            ci.cvvHelpText =
                'Your CVV number is a 3-digit number located after your account number on the signature strip on the back of your card.';
            ci.cvvRegex = CCVRegex.VISA_Disc_MC_CCV();
        }
        if (CreditCardRegex.VISA().test(cardNumber)) {
            ci.cardType = 'VISA';
            // SetCardImageLarge(imgVISA);
            ci.cvvFormat = '000';

            ci.cvvHelpText =
                'Your CVV number is a 3-digit number located after your account number on the signature strip on the back of your card.';
            ci.cvvRegex = CCVRegex.VISA_Disc_MC_CCV();
        }
        if (CreditCardRegex.AMEX().test(cardNumber)) {
            ci.cardType = 'AMEX';
            // SetCardImageLarge(imgAMEX);
            ci.cvvFormat = '0000';
            ci.cvvHelpText = 'Your CVV number is a 4-digit number located on the front of your card.';
            ci.cvvRegex = CCVRegex.AMEX_CCV();
        }

        return ci;
    }
}

export class CCVRegex {
    public static AMEX_CCV(): RegExp {
        return new RegExp('^[0-9]{4}$');
    }
    public static VISA_Disc_MC_CCV(): RegExp {
        return new RegExp('^[0-9]{3}$');
    }
}
//}
